import React, { Component } from "react";
import { Buffer } from "buffer";
import { Button, Form, Input, Modal, notification } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { authApiService } from "../../services/otodis/AuthApiService";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from "universal-cookie";
import { withRouter } from "../../hoc/withRouter";
import "./Login.css";
import { Footer } from "antd/es/layout/layout";
import {appVersion} from "../../config/data/appConfig";

// import {getToken} from '../../services/firebase/messaging';

export interface LoginProps {}

export interface LoginStates extends LoginFields {
  processing: boolean;
  captchaSuccess: boolean;
}

export interface LoginFields {
  username: string;
  password: string;
  pushToken: string;
}

class Login extends Component<LoginProps & any, LoginStates> {
  private cookies = new Cookies();

  constructor(props: LoginProps & any) {
    super(props);

    this.state = {
      processing: false,
      captchaSuccess: false,
      password: "",
      username: "",
      pushToken: "",
    };
  }

  onFieldChange = <T extends keyof LoginFields>(target: T, value: string) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "username":
        currentState.username = value;
        break;
      case "password":
        currentState.password = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  onCaptchaChange = () => {
    this.setState({
      captchaSuccess: true,
    });
  };

  onCaptchaExpire = () => {
    this.setState({
      captchaSuccess: false,
    });
  };

  onErrored = () => {
    this.setState({
      captchaSuccess: true,
    });
  };

  submit = async () => {
    this.setState({
      processing: true,
    });

    try {
      const login = await authApiService.login({
        username: this.state.username,
        password: this.state.password,
        app_code: "otodis",
        token_notification: this.state.pushToken,
      });

      const access_project = login.data.data.access_project;
      const dealerData: any = [];
      for (let item of access_project) {
        dealerData.push({
          DealerCode: item.project_code,
          DealerName: item.project_name,
          DealerCompany: item?.company_code ?? "AMARTA",
        });
      }
      const dealer_default = {
        DealerCode: login.data.data.default_project.project_code,
        DealerName: login.data.data.default_project.project_name,
      };

      await this.cookies.set("_t", login.data.data.token);
      await this.cookies.set("_u", Buffer.from(JSON.stringify(login.data.data.name)).toString("base64"));
      await this.cookies.set("_l", Buffer.from(JSON.stringify(login.data.data.access_level)).toString("base64"));
      await this.cookies.set("_d", Buffer.from(JSON.stringify(dealerData)).toString("base64"));
      await this.cookies.set("_dd", Buffer.from(JSON.stringify(dealer_default)).toString("base64"));
      await this.cookies.set("_am", Buffer.from(JSON.stringify(login.data.data.access_menu)).toString("base64"));

      await authApiService.setToken(login.data.data.token);
      await this.promisedSetState({
        processing: false,
      });

      // setTimeout(() => {
      this.props.history.push("/" + dealer_default.DealerCode.replace(/#/g, "-") + "/dashboard");
      // }, 400);

      // window.location.href = '/';
    } catch (e) {
      Modal.error({
        title: "Login Failed",
        content: "Username atau password tidak cocok",
      });

      this.setState({
        processing: false,
      });
    }
  };

  componentDidMount() {
    // getToken().then(r => {
    //     this.setState({
    //         pushToken: r
    //     })
    // });

    notification.open({
      message: "Kebijakan Cookie",
      description:
        "Kami menggunakan cookies untuk memberikan Anda pengalaman terbaik di website kami. Jika Anda melanjutkan, kami berasumsi bahwa Anda setuju untuk menerima semua cookie dari situs web kami.",
    });
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <div className="login-page">
          <div className="login-box">
            <div className="illustration-wrapper">
              <img src="/assets/img/order.svg" alt="Login" />
            </div>
            <Form name="login-form" initialValues={{ remember: true }}>
              <p className="form-title">App-Otodis</p>
              <p>Login to the Dashboard</p>

              <Form.Item>
                <Input prefix={<UserOutlined />} placeholder={"Username"} size={"middle"} value={this.state.username} onChange={(event) => this.onFieldChange("username", event.target.value)} />
              </Form.Item>
              <Form.Item>
                <Input
                  prefix={<LockOutlined />}
                  type={"password"}
                  placeholder={"Password"}
                  size={"middle"}
                  value={this.state.password}
                  onChange={(event) => this.onFieldChange("password", event.target.value)}
                />
              </Form.Item>

              <div style={{ margin: "25px 0" }}>
                {this.state.captchaSuccess && (
                  <Button onClick={this.submit} loading={this.state.processing} type={"primary"} htmlType={"submit"} size={"large"}>
                    {" "}
                    Login
                  </Button>
                )}
              </div>

              <div style={!this.state.captchaSuccess ? {} : { display: "none" }}>
                <ReCAPTCHA sitekey={"6Ld8YnQaAAAAALF0Y4sxTe55eZ1Xlhu2RtMvUAnd"} onChange={this.onCaptchaChange} onExpired={this.onCaptchaExpire} onErrored={this.onErrored} />
              </div>
            </Form>
          </div>
        </div>
        <Footer style={{ textAlign: "center", backgroundColor: "#d9edff", height: "9vh" }}>
          Otodis ©{new Date().getFullYear()}
          <br />
          v-{appVersion}
        </Footer>
      </React.Fragment>
    );
  }
}

export default withRouter(Login);
